<template>
    <div class="content mt20">
       <div class="account-content bgfff">
            <!-- 导航 -->
            <vipMenu></vipMenu>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="">剩余可添加账号数量：微信公众号 <strong>{{info.wxNum}}</strong> 个；微博号 <strong>{{info.wbNum}}</strong> 个；头条号 <strong>{{info.ttNum}}</strong> 个</div>
           <div class="member-c mt20">
               <div class="member-li" :class="$parent.vipCollocation[levelIndex].className">
                    <div class="member-bg clearfix">
                        <div class="member-level ac fl">
                            <i class="db" :class="$parent.vipCollocation[levelIndex].icon"></i>
                            <span>{{$parent.vipCollocation[levelIndex].name}}</span>
                        </div>
                        <div class="progress progress-member progress-nobg fl" v-if="$parent.vipInfo.level === 1">
                            您现在是免费用户，享有以下权限，开通会员享更多特权！
                        </div>
                        <div class="clearfix fl" v-if="$parent.vipInfo.level != 1">
                            <div class="progress progress-member fl">
                                <div class="progress-bar progress-bar-member" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" :style="{width:''+info.progress+'%'}">
                                    <div class="mb-dt">剩余{{info.surplusDay}}天</div>
                                </div>
                            </div>
                            <span class="sr-only1 color-white">{{info.expireTime}}到期</span>
                        </div>
                        <div class="member-a ac mt5 fr">
                            <router-link v-if="$parent.vipInfo.level === 1" :to="{path:'/personalCenter/permissionComparison'}">开通会员</router-link>
                            <router-link v-if="$parent.vipInfo.level != 1 && $parent.vipInfo.level != 20" :to="{path:'/personalCenter/memberPurchase',query:{'level':info.level}}">会员续费</router-link>
                            <a class="db" href="javascript:void(0);" v-if="$parent.vipInfo.level === 20" @click="contactKefu();">续费</a>
                        </div>
                    </div>
               </div>
               <ul class="member-explain clearfix">
                    <li v-for="(item,index) in plusInfo" :key="index">
                        <i class="icons dui-icon1"></i>
                        <span>{{item}}</span>
                    </li>
                </ul>
           </div>
           <!-- <div class="member-c">
               <div class="member-li member-bgcl1">
                    <div class="member-bg clearfix">
                        <div class="member-level ac fl">
                            <span class="free-user">免费用户</span>
                        </div>
                        <div class="progress progress-member progress-nobg fl">
                            您现在是免费用户，享有以下权限，开通会员享更多特权！
                        </div>
                        <div class="member-a mt5 fr">
                            <router-link class="" to='/member-purchase'>会员续费</router-link>
                        </div>
                    </div>
               </div>
            </div>
            <div class="member-c">
               <div class="member-li member-bgcl2">
                    <div class="member-bg clearfix">
                        <div class="member-level ac fl">
                            <i class="icons db grade-icon2"></i>
                            <span>V1会员</span>
                        </div>
                        <div class="progress progress-member fl">
                            <div class="progress-bar progress-bar-member" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width:40%;">
                                <div class="mb-dt">剩余236天</div>
                            </div>
                        </div>
                        <span class="sr-only1 color-white">2020-07-22到期</span>
                        <div class="member-a mt5 fr">
                            <router-link class="" to='/member-purchase'>会员续费</router-link>
                        </div>
                    </div>
               </div>
            </div>
            <div class="member-c">
               <div class="member-li member-bgcl3">
                    <div class="member-bg clearfix">
                        <div class="member-level ac fl">
                            <i class="icons db grade-icon3"></i>
                            <span>V3会员</span>
                        </div>
                        <div class="progress progress-member fl">
                            <div class="progress-bar progress-bar-member" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width:40%;">
                                <div class="mb-dt">剩余236天</div>
                            </div>
                        </div>
                        <span class="sr-only1 color-white">2020-07-22到期</span>
                        <div class="member-a mt5 fr">
                            <router-link class="" to='/member-purchase'>会员续费</router-link>
                        </div>
                    </div>
               </div>
            </div>
            <div class="member-c">
               <div class="member-li member-bgcl4">
                    <div class="member-bg clearfix">
                        <div class="member-level ac fl">
                            <i class="icons db grade-icon4"></i>
                            <span>机构版会员</span>
                        </div>
                        <div class="progress progress-member fl">
                            <div class="progress-bar progress-bar-member" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width:40%;">
                                <div class="mb-dt">剩余236天</div>
                            </div>
                        </div>
                        <span class="sr-only1 color-white">2020-07-22到期</span>
                        <div class="member-a mt5 fr">
                            <router-link class="" to='/member-purchase'>会员续费</router-link>
                        </div>
                    </div>
               </div>
            </div> -->
        </div>
        <!-- 联系客服 -->
        <Dialog ref="wxModal" title="联系客服" type="normal" width=320 :modalFoot="false">
            <div slot="mdBox">
                <img src="/static/images/kefu.png" class="w100"/>
                <h3 class="ac">请扫描上方微信二维码联系客服续费机构版会员</h3>
            </div>
        </Dialog>
  	</div>
</template>
<script>
import vipMenu from './vipMenu.vue';
import Dialog from '../../components/dialog.vue';
export default {
    components:{vipMenu,Dialog},
    data() {
        return {
            position:'',
            plusInfo:[],//会员权益叙述列表
            levelIndex:0,
            info:[]//会员数据
        }
    },
    mounted() {
		let that = this;
        this.$nextTick(()=> {
            that.getVip();
        })
    },
    created() {
		
    },
    methods: {
        getVip () {
            let that = this;
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post('personal/userinfo',null,r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.plusInfo = r.data.plusInfo;
                    that.info = r.data.info;
                    that.levelIndex = that.$parent.levels.indexOf(r.data.info.level);
                })
            })
        },
        // 联系客服
        contactKefu () {
            let that = this;
            that.$refs.wxModal.showMaskFun();
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/personalCenter.vue